"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAutoLogoutTimer = exports.clearCheckInactivityTimer = exports.setAutoLogoutTimer = exports.setCheckInactivityTimer = void 0;
/* ++++++++++ HELPERs ++++++++++ */
// storing the ids so we can clear them on logout

var autoLogoutTimerId = null; // stores the id for setTimeout which triggers signOut on session expiration.

var checkInactivityTimerId = null; // stores the id for setTimeout func which is triggered when the session is about to expire.

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var setCheckInactivityTimer = function setCheckInactivityTimer(callbackFunc, timeout) {
  // a timeout for 23 hours and 30 minutes to check if user is active 30 mins before the session expires.
  checkInactivityTimerId = setTimeout(function () {
    return callbackFunc();
  }, timeout);
};

exports.setCheckInactivityTimer = setCheckInactivityTimer;

var setAutoLogoutTimer = function setAutoLogoutTimer(callbackFunc, timeout) {
  // auto logout in 30 minutes if no response from user
  autoLogoutTimerId = setTimeout(function () {
    return callbackFunc();
  }, timeout);
};

exports.setAutoLogoutTimer = setAutoLogoutTimer;

var clearCheckInactivityTimer = function clearCheckInactivityTimer() {
  clearTimeout(checkInactivityTimerId);
};

exports.clearCheckInactivityTimer = clearCheckInactivityTimer;

var clearAutoLogoutTimer = function clearAutoLogoutTimer() {
  clearTimeout(autoLogoutTimerId);
};

exports.clearAutoLogoutTimer = clearAutoLogoutTimer;